import request from '@/utils/request'
const apiPath = '/sys/sysGoodsShare'
const sysGoodsShareApi = {
  /**
   * 新增【商品分享文案】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【商品分享文案】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【商品分享文案】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【商品分享文案】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【商品分享文案】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【商品分享文案】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  fetchShareData(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
}
export default sysGoodsShareApi
